'use strict'

import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useRouter } from 'next/router'
import qs from 'qs'

export const styles = (theme) => ({
  /**
   * Styles applied to the root element.
   */
  root: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
})

const useStyles = makeStyles(styles, {
  name: 'RSFSearchForm',
})
/**
 * A form used to submit a search query.
 */
export default function SearchForm({ classes, children, action = '/search', autoComplete = false }) {
  classes = useStyles({ classes })
  const ref = useRef()
  const router = useRouter()

  const handleSubmit = async (e) => {
    e.preventDefault()
    const data = new FormData(ref.current)
    const query = {}
    for (const [name, value] of data.entries()) {
      query[name] = value
    }

    const url = `${action}`
    await router.push(
      {
        pathname: action.split(/\?/)[0],
        query,
      },
      {
        pathname: url,
        query,
      }
    )

    return false
  }
  return React.createElement(
    'form',
    {
      ref,
      action,
      onSubmit: handleSubmit,
      className: classes.root,
      target: '_top',
      autoComplete: autoComplete ? 'on' : 'off',
    },
    children
  )
}

SearchForm.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  action: PropTypes.string,
  autoComplete: PropTypes.bool,
}
